<template>
  <!-- 支付/退款成功弹框 -->
  <custom-dialog
    v-if="dialogVisible"
    width="400px"
    top="23vh"
    :visible="dialogVisible"
    :title="type === 'pay' ? '收费' : '退费'"
    @close="dialogVisible = false"
  >
    <div slot="content">
      <div class="title-text">
        <i class="el-icon-success"></i>
        <h3 v-if="type === 'pay'">收费成功！</h3>
        <h3 v-else>操作成功！</h3>
      </div>
      <div class="content">
        <div class="item">会员姓名：{{ memberInfo.memberName || '' }}</div>
        <div class="item bold">手机号码：{{ memberInfo.phone || '' }}</div>
        <div class="item bold" v-if="type === 'pay'">充值金额：￥{{ orderInfo.amount || 0 }}</div> 
        <div class="item bold" v-else>已退金额：￥{{ orderInfo.refundAmount || 0 }}</div> 
        <div class="item detail" v-if="type != 'pay'">
          <div class="detail_item" v-for="item in orderInfo.refundDetail || []">
            <div v-if="item.walletTradeMethod == 3">好码齐：</div>
            <div v-if="item.walletTradeMethod == 2" >现金：</div>
            <div v-if="item.walletTradeMethod == 11">财务转账：</div>
            <div>￥{{item.amount}}</div>
          </div>
        </div>
        <div class="item">当前余额：￥{{ orderInfo.curAmount || 0 }}</div>
      </div> 
      <div class="footer">
        <el-button type="primary" @click="printHandle">打印{{ typeText }}凭证</el-button>
      </div>
    </div>
    <div slot="footer"></div>
  </custom-dialog>
</template>
 
<script>
  import req from '@/utils/request'
  export default {
    data() {
      return {
        orderInfo: {}
      }
    },
    methods: {
      // 获取订单信息
      async getOrderInfo() {
        const key = this.type === 'pay' ? 'rechargePayNumber' : 'rechargeRefundNumbers'
        const params = {
          [key]: this.orderNum || '',
          memberId: this.memberInfo.memberId
        }
        const reqUrl = this.type === 'pay' ? '/member/wallet/recharge/pay/info' : '/member/wallet/recharge/refund/info'
        const { code, data } = await req.get(reqUrl, params)
        if (code === 200) {
          this.orderInfo = data || {}
        }
      },
      // 打印
      async printHandle() {
        let rechargeRefundlumbers = []
        if(this.type != 'pay'){
          this.orderInfo.refundDetail && this.orderInfo.refundDetail.forEach(item => {
            if(item.refundSuccess !='0'){
              rechargeRefundlumbers.push(item.rechargeRefundNumber)
            }
          })
        }
        const params = {
          id: this.type == 'pay' ? this.orderNum : rechargeRefundlumbers.join(','),
          deptId: this.$session.get('deptId'),
          printType: '1',
          orderType: this.type === 'pay' ? '17' : '18',
        }
        const { code } = await req.post('/cloudprint/printOrder', params)
        if (code === 200) {
          this.$message.success('打印成功')
        }
      }
    },
    props: {
      value: {
        type: Boolean,
        default: false
      },
      type: {  // pay:支付成功  refund:退费成功
        type: String,
        default: 'pay'
      },
      orderNum: {
        type: String | Number,
        default: ''
      },
      memberInfo: {
        type: Object,
        default: () => ({})
      }
    },
    computed: {
      dialogVisible: {
        get() {
          return this.value
        },
        set(val) {
          this.$emit('input', val)
        }
      },
      typeText() {
        return this.type === 'pay' ? '充值' : '退费'
      }
    },
    components: {
      CustomDialog: () => import('@/components/customDialog/CustomDialog')
    },
    watch: {
      dialogVisible(newVal) {
        if (newVal) {
          this.getOrderInfo()
        }
      }
    }
  }
 
</script>

<style scoped lang='less'>
  .title-text {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .title-text .el-icon-success {
    margin-right: 6px;
    font-size: 28px;
    color: #29C01B;
  }

  .content {
    margin-top: 20px;
    color: #667182;
  }
  
  .content .item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 10px auto;
    padding: 0 10px;
    width: 180px;
    font-size: 14px;
    color: #333;
    line-height: 20px;
    &.bold{
      font-weight: 600;
    }
  }

  .footer {
    padding: 16px 0 10px;
    text-align: center;
  }
  .detail{
    display: block !important;
    padding: 8px !important;
    background: #F7F8F9;
    border-radius: 2px;
  }
  .detail_item{
    color: #667182;
    font-size: 12px;
    display: flex;
    justify-content: space-between;
  }
</style>